import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { Dispatch, ReactElement, SetStateAction } from "react"

interface IAppSearchOptionProps {
    title: string
    onClick: () => void
    icon: ReactElement
    setOpen: Dispatch<SetStateAction<boolean>>
}

/** Search options for the search panel. Quick actions are quick start
 * shortcut actions / commands that can be executed from the search panel */
const QuickAction = ({
    title,
    onClick,
    icon,
    setOpen,
}: IAppSearchOptionProps): ReactElement => (
    <ListItemButton
        onClick={() => {
            onClick()
            setOpen(false)
        }}
        sx={{
            ".icon": {
                visibility: "hidden",
            },
            "&:hover .icon, &:focus .icon": {
                visibility: "visible",
            },
        }}
    >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} />
        <ListItemIcon className="icon">
            <ArrowForwardIosIcon />
        </ListItemIcon>
    </ListItemButton>
)

export default QuickAction
